import { c as _c } from "react/compiler-runtime";
import { type SVGProps } from 'react';
import { ContentType } from '@module/mdrt-org/shared/utils/data/constants/content-type';
import { ArticleIcon, AudioIcon, ExternalLinkIcon, VideoIcon } from '@shared/ui-components/svgs';
export const ResourceTypeIcon = t0 => {
  const $ = _c(14);
  let contentType;
  let isExternal;
  let rest;
  if ($[0] !== t0) {
    ({
      contentType,
      isExternal,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = contentType;
    $[2] = isExternal;
    $[3] = rest;
  } else {
    contentType = $[1];
    isExternal = $[2];
    rest = $[3];
  }
  if (isExternal) {
    let t1;
    if ($[4] !== rest) {
      t1 = <ExternalLinkIcon {...rest} />;
      $[4] = rest;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    return t1;
  }
  switch (contentType) {
    case ContentType.Audio:
    case ContentType.Podcast:
      {
        let t1;
        if ($[6] !== rest) {
          t1 = <AudioIcon {...rest} />;
          $[6] = rest;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        return t1;
      }
    case ContentType.Course:
      {
        let t1;
        if ($[8] !== rest) {
          t1 = <ExternalLinkIcon {...rest} />;
          $[8] = rest;
          $[9] = t1;
        } else {
          t1 = $[9];
        }
        return t1;
      }
    case ContentType.Video:
      {
        let t1;
        if ($[10] !== rest) {
          t1 = <VideoIcon {...rest} />;
          $[10] = rest;
          $[11] = t1;
        } else {
          t1 = $[11];
        }
        return t1;
      }
    case ContentType.Article:
    case ContentType.Guide:
    default:
      {
        let t1;
        if ($[12] !== rest) {
          t1 = <ArticleIcon {...rest} />;
          $[12] = rest;
          $[13] = t1;
        } else {
          t1 = $[13];
        }
        return t1;
      }
  }
};